// ref: https://medium.com/@subalerts/create-dynamic-table-from-json-in-react-js-1a4a7b1146ef
import React from "react";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";

export default class ReactCustomTable extends React.Component {
  constructor(props) {
    super(props);
    this.columns = Object.keys(this.props.data[0]).map((key) => {
      return {
        Header: key,
        accessor: key,
        // align:'center',
      };
    });
    // console.log("rendered cols");
    // console.log(this.columns);
  }

  render() {
    return (
      <div>
        <ReactTable
          data={this.props.data}
          columns={this.columns}
          defaultPageSize={5}
          className="-striped -highlight text-center"
        />
      </div>
    );
  }
}
